import {Button} from "@mui/material";
import React, {useState} from "react";
import InfoUpdateModal from "../../modals/update/infoUpdateModal";


export default function AdminInfoUpdate(props){

    const {selectedData, sizeType}=props

    const [modalOpen, setModalOpen] = useState(false);

    const openModal=()=>{
        setModalOpen(true);
    };
    const closeModal=()=>{
        setModalOpen(false);
    }


    return(
        <>
            <Button
                variant="contained"
                size="large"
                onClick={openModal}
                sx={{marginRight:2}}
                disabled={selectedData.length < 1 || selectedData.length >= 2}
            >
                정보수정
            </Button>
            {modalOpen &&
                <>
                    {sizeType === 'mobile' ? (
                        <>
                            <InfoUpdateModal open={modalOpen} close={closeModal} header="단일 정보수정" data={selectedData}
                                             sizeType="mobile" />
                        </>
                    ):(
                        <>
                            <InfoUpdateModal open={modalOpen} close={closeModal} header="단일 정보수정" data={selectedData} />
                        </>
                    )}
                    </>
                }
        </>
    )
}